// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"83709e48","117":"9306d109","127":"b2e5b602","146":"93586898","286":"db78ab68","453":"d7d70089"}[chunkId] + ".chunk.js";
};